export type JobylonBlockFilters = {
    languageCodes?: string[]
    categoryIds?: number[]
    departmentIds?: number[]
    experienceIds?: number[]
    functionIds?: number[]
    internal?: "all" | "internal" | "external"
}

export type JobylonEmbedFilters = {
    language_codes?: string[]
    category_ids?: number[]
    department_ids?: number[]
    experience_ids?: number[]
    function_ids?: number[]
    internal?: "internal" | "external"
}

export function buildJobylonFilters(
    filters?: JobylonBlockFilters
): JobylonEmbedFilters | undefined {
    if (!filters) {
        return undefined
    }

    const embedFilters: JobylonEmbedFilters = {}

    if (filters.languageCodes?.length) {
        embedFilters.language_codes = filters.languageCodes
    }

    if (filters.categoryIds?.length) {
        embedFilters.category_ids = filters.categoryIds
    }

    if (filters.departmentIds?.length) {
        embedFilters.department_ids = filters.departmentIds
    }

    if (filters.experienceIds?.length) {
        embedFilters.experience_ids = filters.experienceIds
    }

    if (filters.functionIds?.length) {
        embedFilters.function_ids = filters.functionIds
    }

    if (filters.internal && filters.internal !== "all") {
        embedFilters.internal = filters.internal
    }

    return Object.keys(embedFilters).length > 0 ? embedFilters : undefined
}
